import Button from "@dustin-web/microsite-components/src/button"
import { useSiteContext, useTranslations } from "@dustin-web/microsite-components/src/hooks"
import { useState } from 'react'
import { Site } from '@dustin-web/microsite-config/src/site-context'
import { useGraphqlMutation } from '@dustin-web/microsite-data/src/hooks'
import {
  ActivationEmailStatus,
  ResendActivationEmail,
  ResendActivationEmailMutation,
  ResendActivationEmailMutationVariables,
} from 'src/graphql/generated/graphql-types'

import { useFormContext } from "react-hook-form"

const getLink = (siteType: Site, siteUrl: string | undefined) => {
  switch (siteType) {
    case 'DustinDenmark':
      return `${siteUrl}/service/levering`
    case 'DustinFinland':
      return `${siteUrl}/service/toimitukset`
    case 'DustinNetherlands':
      return `${siteUrl}/support/klantenservice`
    case 'DustinNorway':
      return `${siteUrl}/service/levering`
    case 'DustinSweden':
      return `${siteUrl}/service/leveranser/leveransinformation`
    default:
      return null
  }
}

const EmailVerificationStep = ({ emailActivationStatus }: { emailActivationStatus?: string }) => {
  const [disableResend, setDisableResend] = useState<boolean>(false)

  const { getValues } = useFormContext()
  const { email } = getValues()

  const { translate } = useTranslations()
  const { siteUrl, site } = useSiteContext()
  const customerServiceLink = getLink(site, siteUrl)

  const [mutation] = useGraphqlMutation<
    ResendActivationEmailMutation,
    ResendActivationEmailMutationVariables
  >(ResendActivationEmail)

  const handleClickResend = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    try {
      const { resendActivationEmail } = await mutation({
        variables: { email: email },
      })
      // TODO handle error case
      if (resendActivationEmail?.status !== 'SUCCESS') {
        console.log('Success')
      } else {
        console.log('Error')
      }
    } catch (error) {
      console.log(error)
    }
    setDisableResend(true)
  }

  if (disableResend) {
    return <>
      <h2 className="u-mb-16">
        {translate('Register_ResendEmail_Popup_Title')}
      </h2>
      <div className="row">
        <div className="col-12 col-lg-7 u-mr-96">
          <p
            className="u-fs-20 u-mb-16"
            dangerouslySetInnerHTML={{
              __html: translate('Register_ResendEmail_ContactCustomerService')
                .replace(
                  '<a>CustomerService</a>',
                  `<a href=${customerServiceLink}>${translate('Register_CustomerService')}</a>`
                ),
            }} />
        </div>
      </div>
    </>
  }
return (
  <div className="d-block" style={{maxWidth: '650px'}}>
    <div className="u-pb-40">
      <h2 className="u-mb-16 u-fs-20 u-fs-lg-28">
        {emailActivationStatus === ActivationEmailStatus.OngoingActivation
          ? translate('Register_UsernameAlreadyRegisteredOnSite')
          : translate('Register_Emailsent_Title')}
      </h2> 
        <p className="u-fs-16 u-fs-lg-16 u-mb-16">
        {translate('Register_Checkyourmailbox')}{' '}
        {translate('Register_Email_Link_Expire')}
      </p>
      </div>
    <div>
      <h3 className="u-fs-16 u-fw-sm-bold u-fs-lg-20">
        {translate('Register_NotReceived_Title')}
      </h3>
      <p className="u-fs-16 u-mb-24">
        {translate('Register_Notreceived_Content')}
      </p>
      <Button
        id="btn-resend-verification-email"
        className="u-w-100 u-w-lg-auto"
        icon="email"
        text={translate('Register_Resend_Email')}
        onClick={handleClickResend}
        disabled={disableResend}
      />
    </div>
  </div>
)



}

export default EmailVerificationStep
